/**
 * File Manager initialization: bootstrapping data required before the
 * File Manager routes can render.
 */

import {
  getConfigurationDetails,
  getCTIDOptions,
} from "@interfaces/config";
import { AppDispatch, RootState } from "@store";
import { loadFilesStart } from "@features/files/actions";
import { addFilesToRedux } from "./files-crud";
import { initialFilesConfig, type Store } from "./files-helpers";

export type FileThunk<R = void> = (
  dispatch: AppDispatch,
  getState: () => RootState
) => Promise<R>;

export const filesInit = (): FileThunk => async (dispatch, getState) => {
  const store: Store = { dispatch, getState };
  store.dispatch(loadFilesStart());
  await getConfigurationDetails(store);
  await Promise.all([
    addFilesToRedux(initialFilesConfig)(dispatch, getState),
    getCTIDOptions(store),
  ]);
};
